<template>
  <TimeslotDashboardLayout>
    <div class="main-content booking prof prof-booking-width">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Subscriptions</h1>
            <div class="tab-text">
              <div class="text-block-37">
                These are the subscriptions made by your clients.All
                subscription times are based on your selected time zone
                <span class="text-span-2"
                  ><strong>{{ customerInfo.customerTimezone }}</strong
                  >.</span
                >
                To update
                <span class="link-6 click-margin" @click="openTime">
                  <strong>Click Here</strong></span
                >
              </div>
              <!--              <a class="link-6" @click="openTime"> Click Here</a>-->
            </div>
            <!--            v-if="subscriptionInfo.length === 0"-->
            <div
              class="no-update_wrapper"
              v-if="subscriptionInfoAlt.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Subscriptions by clients would show up here
                </div>
                <!--              <a href="#" class="explore-professionals_button w-button">Explore professionals</a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      v-if="subscriptionInfo.length !== 0"-->
      <div
        style="display: flex; justify-content: flex-end; margin-top:10px;"
        v-if="subscriptionInfoAlt.length !== 0"
      >
        <div class="filter-size">
          <FormulateInput
            type="select"
            name="bookingStatus"
            placeholder="All"
            style="color: black;"
            :options="['All', 'Client', 'Personal']"
            v-model="filterType"
          />
        </div>
      </div>
      <div
        data-current="Tab 1"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="tabs w-tabs"
        v-if="subscriptionInfoAlt.length !== 0"
        style="margin-top:0;"
      >
        <div class="tabs-menu-2 w-tab-menu">
          <a
            data-w-tab="Tab 2"
            :class="
              pending
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openPending"
          >
            <div>Pending</div>
          </a>
          <a
            data-w-tab="Tab 3"
            :class="
              active
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openActive"
          >
            <div>Active</div>
          </a>
          <a
            data-w-tab="Tab 4"
            :class="
              expired
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openExpired"
          >
            <div>Expired</div>
          </a>
        </div>
        <div class="w-tab-content">
          <div
            data-w-tab="Tab 2"
            v-if="pending"
            :class="pending ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="pendingSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No pending subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>
            <div v-else>
              <div
                v-for="(subscription, index) in pendingSubscriptions"
                :key="index"
                class="subscription-list bookings pending"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscription by
                    <router-link
                      v-if="subscription.type === 'PROFESSIONAL'"
                      :to="`/clients/${subscription.subscriptionCustomerId}`"
                      class="link-5"
                      >{{ subscription.customerName }}</router-link
                    >
                    <router-link
                      v-if="subscription.type === 'CUSTOMER'"
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{ subscription.subscriptionType }}({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          professionalInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client:
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional:
                      </div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            src="@/assets/timeslot-images/profile-picture.png"
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerName }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalName }}
                          </div>
                          <div v-if="subscription.type === 'PROFESSIONAL'">
                            {{ subscription.customerInterest }}
                          </div>
                          <div v-if="subscription.type === 'CUSTOMER'">
                            {{ subscription.professionalSubCategory }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client’s Timezone
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional’s Timezone
                      </div>
                      <div class="div-block-26">
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerTimezone }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    v-if="loader.nonBlockingLoader && accept"
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                  >
                    Loading...
                  </div>
                  <div
                    v-else
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="acceptSubscription(subscription.subscriptionId)"
                  >
                    Accept
                  </div>
                  <div
                    v-if="loader.nonBlockingLoader && decline"
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                  >
                    Loading...
                  </div>
                  <div
                    v-else
                    data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"
                    class="button-4-copy outline w-button"
                    @click="declineSubscription(subscription.subscriptionId)"
                  >
                    Decline
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                </div>
                <div class="div-block-27-copy pending">
                  <div
                    class="text-block-101"
                    v-if="!details || activeIndex !== index"
                  >
                    Pending
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 3"
            v-if="active"
            :class="active ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="activeSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No active subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>

            <div v-else>
              <div
                class="subscription-list bookings pending"
                v-for="(subscription, index) in activeSubscriptions"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscription by
                    <router-link
                      v-if="subscription.type === 'PROFESSIONAL'"
                      :to="`/clients/${subscription.subscriptionCustomerId}`"
                      class="link-5"
                      >{{ subscription.customerName }}</router-link
                    >
                    <router-link
                      v-if="subscription.type === 'CUSTOMER'"
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <!--                      subscription.subscriptionDayString-->
                      <div>
                        {{ subscription.subscriptionType }} ({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          professionalInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client:
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional:
                      </div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            src="@/assets/timeslot-images/profile-picture.png"
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerName }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalName }}
                          </div>
                          <div v-if="subscription.type === 'PROFESSIONAL'">
                            {{ subscription.customerInterest }}
                          </div>
                          <div v-if="subscription.type === 'CUSTOMER'">
                            {{ subscription.professionalSubCategory }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client’s Timezone
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional’s Timezone
                      </div>
                      <div class="div-block-26">
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerTimezone }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                  <!--                <a-->
                  <!--                  data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                  <!--                  href="#"-->
                  <!--                  class="button-4-copy outline w-button"-->
                  <!--                  >Cancel</a-->
                  <!--                >-->
                </div>
                <div class="div-block-27-copy pending">
                  <div class="active" v-if="!details || activeIndex !== index">
                    Active
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 4"
            v-if="expired"
            :class="expired ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div
              class="no-update_wrapper"
              v-if="expiredSubscriptions.length === 0"
            >
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/subscribe.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No expired subscriptions</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>

            <div v-else>
              <div
                class="subscription-list bookings pending"
                v-for="(subscription, index) in expiredSubscriptions"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Subscribed to
                    <router-link
                      v-if="subscription.type === 'PROFESSIONAL'"
                      :to="`/clients/${subscription.subscriptionCustomerId}`"
                      class="link-5"
                      >{{ subscription.customerName }}</router-link
                    >
                    <router-link
                      v-if="subscription.type === 'CUSTOMER'"
                      :to="
                        `/professionals/${subscription.subscriptionProfessionalId}`
                      "
                      class="link-5"
                      >{{ subscription.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{ subscription.subscriptionType }}({{
                          shortDays(subscription.subscriptionDayString)
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <div>
                        {{ subscription.subscriptionStartTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionStartTime) }}
                        -
                        {{ subscription.subscriptionEndTime.slice(0, 5)
                        }}{{ amPm(subscription.subscriptionEndTime) }} ({{
                          professionalInfo.customerTimezone
                        }})
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ subscription.subscriptionAmount }} USD</div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="details && activeIndex === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client:
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional:
                      </div>
                      <div class="div-block-26">
                        <div>
                          <img
                            loading="lazy"
                            width="45"
                            src="@/assets/timeslot-images/profile-picture.png"
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerName }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalName }}
                          </div>
                          <div v-if="subscription.type === 'PROFESSIONAL'">
                            {{ subscription.customerInterest }}
                          </div>
                          <div v-if="subscription.type === 'CUSTOMER'">
                            {{ subscription.professionalSubCategory }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'PROFESSIONAL'"
                      >
                        Client’s Timezone
                      </div>
                      <div
                        class="text-block-25"
                        v-if="subscription.type === 'CUSTOMER'"
                      >
                        Professional’s Timezone
                      </div>
                      <div class="div-block-26">
                        <div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'PROFESSIONAL'"
                          >
                            {{ subscription.customerTimezone }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="subscription.type === 'CUSTOMER'"
                          >
                            {{ subscription.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ subscription.subscriptionTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ subscription.subscriptionMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-27">
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="closeDetails(index)"
                    v-if="details && activeIndex === index"
                  >
                    Hide details
                  </div>
                  <div
                    data-w-id="603342f9-e3a3-15c8-f460-f993fae02cdd"
                    class="button-4 hide w-button"
                    @click="openDetails(index)"
                    v-if="!details || activeIndex !== index"
                  >
                    View details
                  </div>
                </div>
                <div class="div-block-27-copy pending">
                  <div class="expired" v-if="!details || activeIndex !== index">
                    Expired
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import { mapState } from "vuex";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import SubscriptionRequest from "@/model/requests/SubscriptionRequest";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
export default {
  name: "ProfessionalSubscriptions",
  data() {
    return {
      time: false,
      pending: true,
      active: false,
      expired: false,
      details: false,
      bar: true,
      cross: false,
      activeIndex: null,
      readProfModel: SubscriptionRequest.readByProfessionalId,
      readModel: SubscriptionRequest.readByCustomerId,
      acceptModel: SubscriptionRequest.approve,
      declineModel: SubscriptionRequest.decline,
      accept: false,
      decline: false,
      filterType: "All"
    };
  },
  components: {
    TimeslotDashboardLayout,
    UpdateTimezoneModal,
    ProfRightSideMenu
  },
  computed: {
    ...mapState({
      subscriptions: state => state.subscription.professionalSubscriptions,
      subscriptionInfo: state => state.subscription.customerSubscriptions,
      subscriptionInfoAlt: state => state.subscription.customerSubscriptionsAlt,
      professionalInfo: state => state.professional.professionalInfo,
      userInfo: state => state.auth.userInfo,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    pendingSubscriptions() {
      return this.subscriptionInfo.filter(
        item => item.subscriptionStatus === "PENDING"
      );
    },
    activeSubscriptions() {
      return this.subscriptionInfo.filter(
        item => item.subscriptionStatus === "ACTIVE"
      );
    },
    expiredSubscriptions() {
      return this.subscriptionInfo.filter(
        item => item.subscriptionStatus === "EXPIRED"
      );
    },
    ...mapState(["loader"])
  },
  methods: {
    goToProfile() {
      let professionalId;
      if (this.userInfo.professional.professionalId) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    toggleDetails(index) {
      this.activeIndex = index;
      this.details = !this.details;
    },
    openDetails(index) {
      this.activeIndex = index;
      this.details = true;
    },
    closeDetails(index) {
      this.activeIndex = index;
      this.details = false;
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    openPending() {
      this.pending = true;
      this.active = false;
      this.expired = false;
    },
    openActive() {
      this.pending = false;
      this.active = true;
      this.expired = false;
    },
    openExpired() {
      this.pending = false;
      this.active = false;
      this.expired = true;
    },
    shortTimezone(value) {
      let timeStrings = value.split(" ");
      let newList = timeStrings.map(item => item[0]).join("");
      return newList;
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "pm";
      } else {
        return "am";
      }
    },
    shortDays(value) {
      let timeStrings = value.split(",");
      let newList = timeStrings.map(item => item.slice(0, 3));
      let days = newList
        .map(element => {
          return (
            element.charAt(0).toUpperCase() + element.slice(1).toLowerCase()
          );
        })
        .join(",");
      return days;
    },
    acceptSubscription(id) {
      this.accept = true;
      this.decline = false;
      this.acceptModel.subscriptionId = id;
      StoreUtils.dispatch("subscription/approveSubscription", this.acceptModel);
    },
    declineSubscription(id) {
      this.decline = true;
      this.accept = false;
      this.declineModel.subscriptionId = id;
      StoreUtils.dispatch(
        "subscription/declineSubscription",
        this.declineModel
      );
    }
  },
  watch: {
    filterType(newValue) {
      if (newValue.toLowerCase() === "client") {
        StoreUtils.commit(
          "subscription/setCustomerSubscriptions",
          (this.subscriptionInfo = this.subscriptionInfoAlt.filter(
            item => item.type.toLowerCase() === "professional"
          ))
        );
      } else if (newValue.toLowerCase() === "personal") {
        StoreUtils.commit(
          "subscription/setCustomerSubscriptions",
          (this.subscriptionInfo = this.subscriptionInfoAlt.filter(
            item => item.type.toLowerCase() === "customer"
          ))
        );
      } else if (newValue.toLowerCase() === "all") {
        StoreUtils.commit(
          "subscription/setCustomerSubscriptions",
          (this.subscriptionInfo = this.subscriptionInfoAlt)
        );
      }
    }
  },
  mounted() {
    this.readModel.subscriptionCustomerId = this.userInfo.customerId;
    // if ("professional" in this.userInfo) {
    //   this.readModel.subscriptionProfessionalId = this.userInfo.professional.professionalId;
    // } else {
    //   this.readModel.subscriptionProfessionalId = this.customerToProfessionalId;
    // }
    // this.readModel.subscriptionProfessionalId = this.professionalInfo.professionalId;
    StoreUtils.dispatch("subscription/readByCustomerId", this.readModel);
  }
};
</script>

<style scoped>
.prof-booking-width {
  width: 58%;
  margin-left: 0;
}
.filter-size {
  width: 15%;
  margin-right: 20px;
}
@media only screen and (max-width: 790px) {
  .filter-size {
    width: 35%;
    margin-right: 0;
  }
  .prof-booking-width {
    width: 100%;
    margin-left: 25px;
  }
}
@media only screen and (min-width: 791px) and (max-width: 912px) {
  .filter-size {
    width: 20%;
    margin-right: 0;
  }
  .prof-booking-width {
    width: 100%;
    margin-left: 25px;
  }
}
</style>
